import { StudioService, UserService } from '..'
import { BookingStatus, BookingStudioDetails, BookingUserDetails, IBooking, IBookingModel } from '../types/booking'

interface BookingConstructorInput {
  id: string
  status: BookingStatus
  startTime: string
  endTime: string
  studioId?: string
  studio?: BookingStudioDetails
  requesterUserId?: string
  requester?: BookingUserDetails
  hostUserId?: string
  host?: BookingUserDetails
}

export default class Booking implements IBooking {
  id: string
  status: BookingStatus
  studioId: string
  startTime: Date
  endTime: Date
  requesterUserId: string
  hostUserId: string
  studio: BookingStudioDetails
  requester: BookingUserDetails
  host: BookingUserDetails

  private constructor (input: IBookingModel) {
    this.id = input.id
    this.status = input.status
    this.studioId = input.studio.id
    this.startTime = input.startTime
    this.endTime = input.endTime
    this.requesterUserId = input.requester.id
    this.hostUserId = input.host.id
    this.studio = input.studio
    this.requester = input.requester
    this.host = input.host
  }

  private static async fetchStudioDetails (studioId: string): Promise<BookingStudioDetails> {
    try {
      const studio = await StudioService.getStudioById(studioId)
      return {
        id: studio.id,
        title: studio.info.title,
        location: studio.info.location,
        coverPicture: studio.info.studioPictures[0]
      }
    } catch (e) {
      console.log(e)
      console.log(studioId)
      throw e
    }
  }

  private static async fetchUserDetails (userId: string): Promise<BookingUserDetails> {
    const profile = await UserService.getUserProfileByUserId(userId)
    return {
      id: userId,
      firstName: profile?.firstName,
      lastName: profile?.lastName
    }
  }

  static async create (input: BookingConstructorInput): Promise<IBooking> {
    if (!input.studio && !input.studioId) {
      throw new Error('Booking must have a studio')
    }
    if (!input.requester && !input.requesterUserId) {
      throw new Error('Booking must have a requester')
    }
    if (!input.host && !input.hostUserId) {
      throw new Error('Booking must have a host')
    }
    const studio: BookingStudioDetails = input.studio ?? await Booking.fetchStudioDetails(input.studioId as string)
    const requester = input.requester ?? await Booking.fetchUserDetails(input.requesterUserId as string)
    const host = input.host ?? await Booking.fetchUserDetails(input.hostUserId as string)
    return new Booking({
      id: input.id,
      status: input.status,
      studio,
      startTime: new Date(input.startTime),
      endTime: new Date(input.endTime),
      requester,
      host
    })
  }
}
